module.exports = __webpack_public_path__ + "img/tourne-express.6b6959a5.png";